<!--
 * @Author: WeiZisen
 * @Date: 2021-03-15 11:13:04
 * @LastEditors: pengmiaopei
 * @LastEditTime: 2022-04-19 21:23:25
 * @Description: 1.这是app.vue文件，
                  我们知道，app.vue是我们看到的初始化页面的载体，
                  这里的关键点是在声明的vue容器里，
                  这里只能写<router-view></router-view>标签，该
                  标签是用来显示匹配上的路由相对应的组件内容。
             2.出发跳转页面机制以后，
             则App.vue里<router-view></router-view>标签里匹配到的就是制定跳转的路由，
             页面渲染路由对应的组件内容，则实现页面完全跳转。               
 * @FilePath: \Design_Vue_pmp\src\App.vue
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
  }
</script>
